import React from 'react';
import './Vicepresidentmessage.css';
import pic2 from "../assets/Himanshu B.jpg";

const VicePresidentMessage = () => {
  const councilMembers = [
    { name: 'Sh. Jaideep Bihani', role: '(President)' },
    { name: 'Sh. Himanshu Bihani', role: '(Vice President)' },
    { name: 'Mrs. Nalini Dhingra', role: '(Principal & Secretary)' },
    { name: 'Sh. Deepak Jain S/o Sh. Manmohan Jain', role: ' (Member/Trustee)' },
    { name: 'Sh. Madhu Sudan Bihani S/o Sh. Suhil Kumar Bihani', role: ' (Member/Trustee)' },
    { name: 'Sh. Sharad Kumar Bihani', role: '(Member/Trustee)' },
    { name: 'Sh. Vimal Bihani', role: '(Member)' },
    { name: 'Sh. Satish Chander Jain', role: '(Member)' },
    { name: 'Smt. Ranjana Bihani', role: '(Member)' },
    { name: 'Smt. Shailja Chitlangyia W/o Sh. Rakesh Chitlangyia', role: ' (Member)' },
    { name: 'Smt. Shruti Bihani W/o Sh. Neeraj Bihani', role: ' (Member)' },
    { name: 'Smt. Monika Bihani', role: '(Member)' },
    { name: 'Smt. Urmila Chitlangyia D/o Sh. Shankar Lal Bhattar', role: ' (Member)' },
    { name: 'Smt. Kavita Binnani W/o Sh. Prashant Binnani', role: ' (Member)' },
    { name: 'Dr. Richa Periwal W/o Dr. Aditya Periwal', role: ' (Member)' },
    { name: 'Sh. M.S. Vig - Principal CBSE School', role: ' (Member)' },
    { name: 'Smt. Minu Sharma - Principal CBSE School', role: ' (Member)' },
    { name: 'Smt. Nalini Dhingra - Academy Teacher', role: ' (Member)' },
    { name: 'Sh. Varun Maheshwari Member', role: ' (Lecturer Other Dept)' },
    { name: 'Dr. Gulshan Kumar', role: '(College Lecturer)' },
    { name: 'Dr. Ajay Sharma', role: '- Present Students Parents' },
    { name: 'Present Students Parents', role: '' },
  ];

  return (
    <>
    {/* Banner Section with Background Image */}
      <section className="inner-bannerlib">
        <div className="banner-container">
          <h1>MESSAGE FROM VICE PRESIDENT</h1>
        </div>
      </section>

      {/* Breadcrumb */}
      <section className="breadcrumb-section">
        <div className="breadcrumb-container">
          <ul className="breadcrumb-list">
            <li><a href="/">Home</a></li>
            <li>/</li>
            <li>Vice President</li>
          </ul>
        </div>
      </section>
    <div className="page-container">
      <div className="main-container">
        <div className="header">
          <h1 className="header-title">Vice President's Message</h1>
        </div>

        <div className="content">
          <div className="left-section">
            <div className="president-card">
              <div className="vice-president-img">
                <img src={pic2} alt="Vice President Himanshu Bihani" />
              </div>
             <p className="vp-profile-designation">VICE PRESIDENT</p>
                <h2 className="vp-profile-fullname">MR. HIMANSHU BIHANI</h2>
                <p className="vp-profile-position">Vice President Seth G.L. Bihani S.D. Shiksha Trust & Bihani Children's Academy</p>
            </div>

            <div className="quote-box">
                "The beautiful thing about learning is that no one can take it away from you"
            </div>

            <div className="mission-box">
              <p> Education is the most powerful tool for shaping minds, building character, and creating a progressive society. At Bihani Children’s Academy, we strongly believe that education is not limited to academic achievement alone, but is a lifelong journey of learning, self-discovery, and personal growth. Our mission is to provide an environment where students are encouraged to think independently, act responsibly, and grow confidently. </p>
              <p>   Guided by our core philosophy, Projection Towards Perfection, we are committed to continuous improvement in every dimension of education. This vision motivates us to constantly raise standards, embrace innovation, and strive for excellence. We encourage our students to challenge themselves, learn from experiences, and develop resilience, perseverance, and a passion for lifelong learning.   </p>
               <p> At Bihani Children’s Academy, holistic development lies at the heart of our educational approach. Along with strong academic foundations, we place equal emphasis on sports, cultural activities, leadership opportunities, and community service. These experiences help students develop teamwork, discipline, creativity, and empathy—qualities essential for success in the real world.   </p>
               <p> Our dedicated and experienced educators play a vital role in shaping young minds. By integrating modern teaching methodologies with technology-enabled learning, we ensure that our students are well-prepared to meet global challenges. We focus on nurturing critical thinking, problem-solving skills, and innovation, enabling students to adapt confidently to an ever-evolving world.     </p>
               <p> We also believe that values and ethics are the true pillars of education. Through a supportive and inclusive learning environment, we aim to instill integrity, respect, responsibility, and social awareness in every child. Our goal is to empower students to become not only successful professionals but also compassionate and responsible citizens.     </p>
               <p>At Bihani Children’s Academy, we are committed to partnering with parents and the community to provide a safe, inspiring, and value-driven educational experience. Together, we aspire to shape future leaders who will contribute positively to society and the nation with knowledge, confidence, and character.    </p>
            </div>
          </div>

          {/* Management Council Sidebar */}
        <div className="bca-council-box">
          <h2 className="bca-council-title">Management Council</h2>
          <ul className="bca-council-members">
            {councilMembers.map((member, index) => (
              <li key={index} className="bca-council-member">
                <strong>{member.name}</strong> {member.role && <span>{member.role}</span>}
              </li>
            ))}
          </ul>
        </div>
        </div>
      </div>
    </div>
              </>
  );
};

export default VicePresidentMessage;